import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import enUs from '../../../../lang/en-us';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { checkForOnlyAlphabets } from '../../../../utils/constants';
import { isError, showHelperText } from '../Switch/utils';
import AsyncLoader from '../../../../lib/AsyncLoader';
import { TabElementSkeleton } from '../ExploreMFs/mf-investment';

const { dbCommercial } = enUs;

export default function UserDetails({ formik, latestDataCalled }: any) {
    const { email, mobile } = useSelector(({ authReducer }: RootStateType) => ({
        ...authReducer,
    }));
    return (
        <>
            <h5>{dbCommercial.exploreMfs.eMandate.enterFollowing}</h5>
            <div className="new-otm-fields">
                <AsyncLoader data={latestDataCalled} skelton={<TabElementSkeleton width={250} />}>
                    <TextField
                        id="investor-pan"
                        label={dbCommercial.exploreMfs.eMandate.fields.investorPan}
                        variant="outlined"
                        value={formik.values.pan}
                        InputProps={{
                            readOnly: true,
                        }}
                        name="pan"
                    />
                </AsyncLoader>
                <AsyncLoader data={latestDataCalled} skelton={<TabElementSkeleton width={250} />}>
                    <TextField
                        id="investor-name"
                        label={dbCommercial.exploreMfs.eMandate.fields.investorName}
                        variant="outlined"
                        value={formik.values.name}
                        // onChange={(e) => {
                        //     if (checkForOnlyAlphabets(e.target.value)) {
                        //         formik.setFieldValue('name', e.target.value);
                        //     }
                        // }}
                        InputProps={{
                            readOnly: true,
                        }}
                        // onBlur={formik.handleBlur}
                        name="name"
                    // helperText={showHelperText(formik, 'name')}
                    // error={isError(formik, 'name')}
                    />
                </AsyncLoader>
                <AsyncLoader data={latestDataCalled} skelton={<TabElementSkeleton width={250} />}>
                    <TextField
                        id="investor-mail"
                        label={dbCommercial.exploreMfs.eMandate.fields.investorMail}
                        variant="outlined"
                        helperText={showHelperText(formik, 'email')}
                        error={isError(formik, 'email')}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        InputProps={{
                            readOnly: !!email,
                        }}
                        value={formik.values.email}
                        name="email"
                    />
                </AsyncLoader>
                <AsyncLoader data={latestDataCalled} skelton={<TabElementSkeleton width={250} />}>
                    <TextField
                        id="investor-mobile"
                        label={dbCommercial.exploreMfs.eMandate.fields.mobileNo}
                        variant="outlined"
                        helperText={showHelperText(formik, 'mobile')}
                        error={isError(formik, 'mobile')}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        InputProps={{
                            readOnly: !!mobile,
                            inputMode: 'numeric',
                        }}
                        value={formik.values.mobile}
                        name="mobile"
                    />
                </AsyncLoader>
            </div>
        </>
    );
}
